export default __webpack_public_path__ + "static/media/close.57dc677a.svg";